import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css';

const QUICK_LINKS = [
  { label: 'About Us', to: '/about' },
  { label: 'Our Programs', to: '/programs' },
  { label: 'Our Impact', to: '/impact' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact Us', to: '/contact' },
];

const CAUSES = [
  { label: 'Education for All', to: '/programs#education' },
  { label: 'Healthcare Access', to: '/programs#healthcare' },
  { label: 'Women Empowerment', to: '/programs#women' },
  { label: 'Rural Development', to: '/programs#rural' },
  { label: 'Child Welfare', to: '/programs#children' },
];

const SOCIAL = [
  { icon: 'f', label: 'Facebook' },
  { icon: '𝕏', label: 'Twitter/X' },
  { icon: 'in', label: 'LinkedIn' },
  { icon: '▶', label: 'YouTube' },
  { icon: '📸', label: 'Instagram' },
];

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo" aria-label="Shine People Trust">
                <img src={logo} alt="Shine People Charitable Trust" className="footer-logo-img" />
              </Link>
              <p className="footer-desc">
                Dedicated to creating sustainable change through education, healthcare, and community development. Together, we build brighter futures.
              </p>
              <div className="footer-social" role="list" aria-label="Social media links">
                {SOCIAL.map(s => (
                  <button key={s.label} className="social-link" aria-label={s.label}>
                    {s.icon}
                  </button>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="footer-col-title">Quick Links</h3>
              <nav aria-label="Footer quick links">
                <ul className="footer-links">
                  {QUICK_LINKS.map(l => (
                    <li key={l.to}>
                      <Link to={l.to} className="footer-link">{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            {/* Causes */}
            <div>
              <h3 className="footer-col-title">Our Causes</h3>
              <nav aria-label="Footer causes links">
                <ul className="footer-links">
                  {CAUSES.map(c => (
                    <li key={c.label}>
                      <Link to={c.to} className="footer-link">{c.label}</Link>
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="footer-contact-items" style={{ marginTop: '1.5rem' }}>
                <div className="footer-contact-item">
                  <span className="icon">📍</span>
                  <span>Papermills Road, Periyar Nagar, Chennai</span>
                </div>
                <div className="footer-contact-item">
                  <span className="icon">✉️</span>
                  <span>info@shinepeopletrust.org</span>
                </div>
              </div>
            </div>

            {/* Get Involved */}
            <div className="footer-newsletter">
              <h3 className="footer-col-title">Get Involved</h3>
              <p className="newsletter-text">
                Join our community of volunteers and changemakers. Every action creates a ripple of positive change.
              </p>
              <a
                href="https://grantalife.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="newsletter-btn"
                style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none', marginTop: '0.5rem' }}
              >
                Get Involved
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <p className="footer-copy">
              © {new Date().getFullYear()} Shine People Trust. All rights reserved.{' '}
              Reg. No. <span>TN/2024/TRUST/0001</span>
            </p>
            <nav aria-label="Footer legal links">
              <ul className="footer-bottom-links">
                <li><Link to="/privacy" className="footer-bottom-link">Privacy Policy</Link></li>
                <li><Link to="/terms" className="footer-bottom-link">Terms of Use</Link></li>
                <li><Link to="/sitemap" className="footer-bottom-link">Sitemap</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
